kimal.globalDistribution = {};
kimal.globalDistribution.ajaxUrl = '../mock/global-dist.json';
kimal.globalDistribution.searchResultsContainer = $('.global-distribution-search__results');
kimal.globalDistribution.searchResultsList = $('.global-distribution-search__results-list');

kimal.globalDistribution.removeResults = function(submit) {
  if(submit) {
    kimal.globalDistribution.searchResultsList.html('');
  } else {
    kimal.globalDistribution.searchResultsContainer.removeClass('show');
    kimal.globalDistribution.searchResultsContainer.one('transitionend', function() {
      kimal.globalDistribution.searchResultsList.html('');
    });
  }
}

$('#global-distribution-search').on('submit', function(event) {
  event.preventDefault();
  var $form      = $(this),
      searchTerm = $form.find('.form__input--search').val();

  if(!searchTerm) {
      return false;
  } else {
    $form.find('.input--submit-btn').addClass('busy');

    if (!kimal.development) {
      kimal.globalDistribution.ajaxUrl = window.ajaxurl + '?' + $.param({
        action:  'distribution_centres_ajax_lookup',
        nonce:   $('#global-distribution-search input[name="nonce"]').val(),
        address: searchTerm
      });
    }
    kimal.globalDistribution.req = new AJAX_REQUEST(kimal.globalDistribution.ajaxUrl, $('.global-distribution-search__results'), 'Oops! something went wrong.');
    kimal.globalDistribution.req.getData(function(data, status, xhr) {
      var htmlString = '',
          results    = data;

          if (kimal.development) {
            var regex = new RegExp('.*' + searchTerm.toLowerCase() + '.*'),
            results = data.filter(function(distCenter) {
              return distCenter.location.toLowerCase().match(regex);
            });
          }

          kimal.globalDistribution.removeResults('submit');

          if(results.length > 0) {
            htmlString += '<li><h4 class="global-distribution-search__results__heading">Your closest distribution centres&hellip;</h4></li>';
            for (var i = 0; i < results.length; i++) {
              htmlString += '<li class="global-distribution-search__results-item">';
              htmlString += '<div class="global-distribution-search__results-section">';
              htmlString += '<a class="global-distribution-search__results-item__link" href="' + results[i].url + '" title="' + results[i].title + '">';
              htmlString += '<h4 class="global-distribution-search__results-item__heading">' + results[i].title + '</h4>';

              if (Object.keys(results[i].region).length) {
                htmlString += '<div class="global-distribution-search__results-item__region">';
                htmlString += '<span class="flag-icon flag-icon-' + results[i].region.iso + '"></span>';
                htmlString += '<span class="global-distribution-search__results-item__region__name">' + results[i].region.name + '</span>';
                htmlString += '</div>';
              }

              htmlString += '</a>';
              htmlString += '</div>';
              htmlString += '</li>';
            }
          } else {
            htmlString = '<li>There are no distribution centers in this area</li>'
          }
          htmlString += '<li><a href="/worldwide-distribution/" title="Distribution Centres">See all distribution centres</a></li>';

          kimal.globalDistribution.searchResultsList.append(htmlString);
          kimal.globalDistribution.searchResultsContainer.addClass('show');
          $form.find('.input--submit-btn').removeClass('busy');
    });
  }
});

$('#global-distribution-search__input').on('keyup', function(event) {
  if(!$(this).val() && event.keyCode !== 13) {
    kimal.globalDistribution.removeResults();
  }
});
